module.exports = __webpack_public_path__ + "static/img/traffic-light-grey.3e3611c.png";